
import React, { useMemo } from 'react'
import { Card } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import * as echarts from 'echarts/core';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { EChartsOption } from 'echarts';

import useTranslation from '@/Hooks/UseTranslation';

import Skeleton from './Skeleton';

import './TasksStatus.scss'
interface Props {
  tasks: any
}

const TasksStatus = ({ tasks }: Props) => {

  const { t } = useTranslation()


  const colorMap: { [key: string]: string } = {
    'activa': '#34a854',
    'pendiente': '#FAEC4490',
    'atrasada': '#ff0000',
    'completada': '#E0E0E0',
    'activa-atrasada': '#c04f14',
    'liberada': '#006ebc'
  }

  const data = useMemo(() => {

    const output = []
    const activas = tasks?.filter((task: any) => task.raw.status === 'activa') || []
    const activas_atrasadas = tasks?.filter((task: any) => task.raw.status === 'activa-atrasada') || []
    const pendientes = tasks?.filter((task: any) => task.raw.status === 'pendiente') || []
    const atrasadas = tasks?.filter((task: any) => task.raw.status === 'atrasada') || []
    const completadas = tasks?.filter((task: any) => task.raw.status === 'completada') || []
    const liberadas = tasks?.filter((task: any) => task.raw.status === 'liberada') || []

    output.push({ label: t('PROJECT_DASHBOARD:TasksStatusActiveTasks'), value: activas.length, itemStyle: { color: colorMap['activa'] } })
    output.push({ label: t('PROJECT_DASHBOARD:TasksStatusPendingTasks'), value: pendientes.length, itemStyle: { color: colorMap['pendiente'] } })
    output.push({ label: t('PROJECT_DASHBOARD:TasksStatusOverdueTasks'), value: atrasadas.length, itemStyle: { color: colorMap['atrasada'] } })
    output.push({ label: t('PROJECT_DASHBOARD:TasksStatusCompletedTasks'), value: completadas.length, itemStyle: { color: colorMap['completada'] } })
    output.push({ label: t('PROJECT_DASHBOARD:TasksStatusActiveOverdueTasks'), value: activas_atrasadas.length, itemStyle: { color: colorMap['activa-atrasada'] } })
    output.push({ label: t('PROJECT_DASHBOARD:TasksStatusReleasedTasks'), value: liberadas.length, itemStyle: { color: colorMap['liberada'] } })

    return output
  }, [tasks])

  const totalTasks = useMemo(() => {
    return data.reduce((sum, item) => sum + item.value, 0)
  }, [data])

  const option: EChartsOption = {
    tooltip: {
      trigger: 'item'
    },
    legend: {
      show: false,
      bottom: 0
    },
    series: [
      {
        type: 'pie' ,
        label: {
          show: true,
          position: 'center',
          formatter: `{a|Total}\n{b|${totalTasks}}`,
          rich: {
            a: {
              color: '#666',
              fontSize: 14,
              lineHeight: 20
            },
            b: {
              color: '#333',
              fontSize: 24,
              fontWeight: 'bold',
              lineHeight: 30
            }
          }
        },
        labelLine: {
          show: false
        },
        itemStyle: {
          borderRadius: 0,
          borderColor: '#fff',
          borderWidth: 1
        },
        data: data.map((item: any) => ({ name: item.label, value: item.value, itemStyle: item.itemStyle })),
        height: 260,
        radius: ['80%', '90%'],
      },

    ]
  }

  return (
    <>
      {!data && (
        <Skeleton width={'100%'} height={320} borderRadius={10} count={1} />
      )}
      {data && (
        <Card>
          <Card.Body>
            <h4 className='card-title'>
              {t('PROJECT_DASHBOARD:TasksStatusTitle')}
            </h4>
            <div className='tasks-status'>
              <div className='chart-container'>
                <ReactEChartsCore
                  echarts={echarts}
                  option={option}
                  style={{ height: '260px', width: '100%' }}
                />
              </div>
              <div className='status-container'>
                {data.filter((item) => item.value || totalTasks === 0).map((item: any, i: number) => (
                  <div key={i} className='status-item'>
                    <div className='dot' style={{ backgroundColor: item.itemStyle.color }}></div>
                    <div>
                      <div className='status-item-label'>
                        {item.label}
                      </div>
                      <div className='status-item-value'>
                        {item.value}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Card.Body>
        </Card>
      )}
    </>
  )
}

export default TasksStatus
